import React from "react"
import { connect } from "react-redux"
import Cookies from "js-cookie"

import { push } from "connected-react-router"
import CoolPage from "../components/CoolPage"
import Characteristics from "./components/Characteristics"

import "./Tepa.less"

class Tepa extends React.PureComponent {
  componentDidMount() {
    const room = Cookies.get("tepaRoom")
    if (!room) {
      console.log("gonna ask for the room number")
      this.props.gotoAsk()
    }
  }
  
  render() {
    return (
      <CoolPage
        containerProps={{ className: "tepa" }}
        title="NH Palacio de Tepa"
        barColor={[238, 237, 235]}
        className="tepaPage"
        isChevron={false}
      >
        <div className="tepa-page-2">
          <div className="principal-image">
            <div className="principal-image-text-container"> 
              <h2>NH Collection Madrid<br />Palacio de Tepa</h2>
            </div>
          </div>

          <div className="description">
            <h1>欢迎来到NH酒店</h1>
            <p>
              NH Hotel Group是一家成立于1978年的西班牙酒店跨国公司，总部设于马德里，
              在欧洲连锁商务酒店中排名第三。NH Hotels，NH Collection和nhow是公司旗下的三个品牌，
              在欧洲北美拉美亚洲的三十个国家开设了近四百家酒店。
            </p>
          </div>

          <div className="services">
      
            <h2>付费服务</h2>
      
            <div
              className="button dormitorio"
              onClick={this.props.gotoRooms}
            >
              <label>客房</label>
            </div>

            <div className="row">
              <div className="button lavanderia" onClick={this.props.gotoLaundry}>
                <label>洗衣房</label>
              </div>
              <div className="button spa">
                <label>温泉</label>
              </div>
            </div>
      
            <div className="button restaurant" onClick={this.props.gotoRestaurant}>
              <label>客房</label>
            </div>

            {/* <img src="/static/img/nh/banner_NH_casino.jpg" className="banner" /> */}

            <h2>付费服务</h2>

            <div className="button gym" >
              <label>健身房</label>
            </div>

            <h2>酒店特点</h2>
      
            <Characteristics 
              list={[
                "estacionamiento",
                "aireAcondicionado",
                "kids", 
                "accesibilibity", 
                "meeting", 
              ]}
            />

          </div>
          <div
            className="zsx-banner"
            onClick={() => this.props.gotoHome()}
          >
            <p>了解掌上app！</p>
            <p>您可以购买和预订餐位在马德里餐厅</p>
          </div>
        </div>
      </CoolPage>
    )
  }
}

const mapStateToProps = (_state, _ownProps) => ({ })

const mapDispatchToProps = dispatch => {
  const goto = url => dispatch(push(url))
  return {
    goto,
    gotoAsk: () => goto('/catalogo/tepa/ask'),
    gotoHome: () => goto('/catalogo/Madrid/citypage'),
    gotoLaundry: () => goto(`/catalogo/tepa/laundryInfo`),
    gotoRestaurant: () => goto('/catalogo/tepa/restaurant'),
    gotoRooms: () => goto('/catalogo/tepa/rooms'),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Tepa)



// WEBPACK FOOTER //
// ./src/app/catalogo/hotels/Tepa.jsx